import { requestGet, requestPost } from '@/common/request';

export default {
  // J62、黑白名单明细数据列表
  // cf:https://joyspace.jd.com/pages/VY48ytyWxH3ORLEaH7NP
  async listWhiteBlackItem(query) {
    return await requestGet('/merchantPool/listWhiteBlackItem', query);
  },
  // J63、是否上传过黑白名单数据
  // https://joyspace.jd.com/pages/KR14G3wS7XZhhQKxGGqg
  async isWhiteBlackItem(query) {
    return await requestGet('/merchantPool/isWhiteBlackItem', query);
  },
};
